<template>
  <div>
    <main-header
      :title="$t('my-card.my-card-title')"
    >
      <div class="background-site">
        <div class="member-card-box">
          <el-card shadow="alway" class="member-card">
            <div class="user-info">
              <div>
                <div>{{$t('my-card.member-name')}}</div>
                <div class="user-info-bold">{{userInfo.name}}</div>
              </div>
              <div>
                <div>{{(userInfo.point >= -1 && userInfo.point &lt;= 1) ? $t('my-card.point') : $t('my-card.points')}}</div>
                <div class="user-info-bold user-info-point"><points class="mr-3" />{{numberWithCommas(userInfo.point == "" ? 0 : userInfo.point)}}</div>
              </div>
            </div>
            <figure class="qrcode">
              <qrcode
                :value="qrParam.token"
                :options="{
                  errorCorrectionLevel: 'M',
                  width: 248,
                }"
              ></qrcode>
              <img
                class="qrcode__image"
                :src="require(`@/assets/img/fs-logo.png`)
                "
              />
            </figure>
            <div class="text-center" style="font-size: 18px;"><i class="el-icon-refresh-right mr-3 refesh-btn" @click="reQRcode"></i>{{ timeout }}</div>
          </el-card>
          <div class="description-text">
            <div>{{$t('my-card.description-1')}}</div>
            <div>{{$t('my-card.description-2')}}</div>
          </div>
        </div>
      </div>
    </main-header>
    <main-footer />
  </div>
</template>

<script>
import MainFooter from '@components/MainFooter'
import MainHeader from '@components/MainHeader'
import { mapActions, mapGetters } from "vuex"
import moment from 'moment'
import Points from '@/components/icons/Points.vue'
import mixins from '@/helper/mixins'

export default {
  components: {
    MainHeader,
    MainFooter,
    Points,
  },
  mixins: [mixins],
  data() {
    return {
      timeout: "00:00",
      clearTimeout: false,
      qrParam: {
        token: 'token',
        exp: null
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "user/userInfo",
      userToken: "user/userToken",
      branchUUID: "branch/branchUUID",
    }),
  },
  mounted () {
    this.reQRcode() 
  },
  methods: {
    ...mapActions({
      getMyCardQRCode: "user/getMyCardQRCode",
    }),
    onClickLeftBtn() {
      this.$router.go(-1)
    },
    setCountDown() {
      clearInterval(this.clearTimeout)
      const now = moment()
      const expiration = this.qrParam.exp ? moment(this.qrParam.exp * 1000) : now
      const diff = expiration.diff(now) + 1000
      var duration = moment.duration(diff, "milliseconds")
      var interval = 1000
      if(duration.days() < 1) {
        this.clearTimeout = setInterval(() => {
          duration = moment.duration(duration - interval, "milliseconds");
          this.timeout = `${duration.minutes()}:${("0" + duration.seconds()).slice(-2)}`;
        }, interval);
        setTimeout(() => {
          clearInterval(this.clearTimeout)
          this.timeout = '00:00'
        }, diff);
      } else {
        this.timeout = expiration.format('DD/MM/YYYY')
      }
    },
    async reQRcode() {
      await this.getMyCardQRCode({
        branchUUID: this.branchUUID,
        type: 1
      }).then(async (response) => {
        if (response) {
          this.qrParam = response
          this.setCountDown()
        }
      });
    }
  }
}
</script>

<style scoped>
  .background-site {
    background-color: var(--background-color);
    margin-top: 90px;
    padding: 16px;
    min-height: calc(100vh - 90px - 60px - var(--header-height));
  }
  .member-card-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin-top: -112px;
  }
  .member-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #ffffff;
      width: 100%;
      margin: 0 16px;
      border-radius: 16px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  }
  .description-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 24px;
    font-size: 18px;
    color: #6A7180;
  }

  .qrcode {
    display: inline-block;
    font-size: 0;
    margin-bottom: 0;
    position: relative;
  }

  .qrcode__image {
    background-color: #fff;
    padding: 4px;
    height: 15%;
    left: 50%;
    overflow: hidden;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 15%;
  }

  .user-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    color: #333333;
    font-size: 16px;
  }

  .user-info-bold {
    font-size: 22px;
    font-weight: 500;
  }

  .user-info-point {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
  }

  .refesh-btn {
    cursor: pointer;
  }
</style>